import React from 'react';
import SchedulingPageV2 from './personnel-scheduling/index';

const PersonnelSchedulingPage: React.FC = () => {
  return <SchedulingPageV2 />;
};

export default PersonnelSchedulingPage;
